export const benchmarkRequestEndpoints = {
  searchCompanies: "/benchmark-requests/companies/search",
  suggestCompanies: "/benchmark-requests/companies/suggested",
  create: "/benchmark-requests",
  mine: "/benchmark-requests/mine",
  listAll: "/benchmark-requests",
  updateStatus: (id) => `/benchmark-requests/${id}/status`,
};
